import React from 'react';

import Header from '../../layout/Header.jsx';
import ListPlayers from '../../lists/ListPlayers.jsx';

const PagePlayersList = () => (
  <div>
    <Header>Players</Header>
    <ListPlayers />
  </div>
);

export default PagePlayersList;
